import React, { useContext } from 'react';
import { ShopContext } from '../context/ShopContext';
import { FaTimes, FaMinus, FaPlus } from 'react-icons/fa';

const Cart = () => {
    const { isCartOpen, checkout, closeCart, updateLineItemQuantity } = useContext(ShopContext);

    if (!isCartOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-hidden">
            <div className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={closeCart}></div>
            <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
                <div className="w-screen max-w-md">
                    <div className="h-full flex flex-col bg-white shadow-xl overflow-y-scroll">
                        <div className="flex-1 py-6 overflow-y-auto px-4 sm:px-6">
                            <div className="flex items-start justify-between">
                                <h2 className="text-lg font-medium text-gray-900">Sepetiniz</h2>
                                <div className="ml-3 h-7 flex items-center">
                                    <button
                                        type="button"
                                        className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                                        onClick={closeCart}
                                    >
                                        <span className="sr-only">Kapat</span>
                                        <FaTimes aria-hidden="true" />
                                    </button>
                                </div>
                            </div>

                            <div className="mt-8">
                                <div className="flow-root">
                                    {checkout.lineItems && checkout.lineItems.length > 0 ? (
                                        <ul className="-my-6 divide-y divide-gray-200">
                                            {checkout.lineItems.map((item) => (
                                                <li key={item.id} className="py-6 flex">
                                                    <div className="flex-shrink-0 w-24 h-24 border border-gray-200 rounded-md overflow-hidden">
                                                        <img
                                                            src={item.variant.image.src}
                                                            alt={item.title}
                                                            className="w-full h-full object-center object-cover"
                                                        />
                                                    </div>

                                                    <div className="ml-4 flex-1 flex flex-col">
                                                        <div>
                                                            <div className="flex justify-between text-base font-medium text-gray-900">
                                                                <h3>
                                                                    <a href={item.variant.product.onlineStoreUrl}>{item.title}</a>
                                                                </h3>
                                                                <p className="ml-4">{item.variant.price.amount} {item.variant.price.currencyCode}</p>
                                                            </div>
                                                            <p className="mt-1 text-sm text-gray-500">{item.variant.title !== 'Default Title' ? item.variant.title : ''}</p>
                                                        </div>
                                                        <div className="flex-1 flex items-end justify-between text-sm">
                                                            <div className="flex items-center border border-gray-300 rounded-md">
                                                                <button
                                                                    type="button"
                                                                    className="p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-l-md transition-colors"
                                                                    onClick={() => updateLineItemQuantity(item.id, item.quantity - 1)}
                                                                >
                                                                    <FaMinus size={12} />
                                                                </button>
                                                                <span className="px-4 py-1 text-gray-900 font-medium border-l border-r border-gray-300 min-w-[3rem] text-center">
                                                                    {item.quantity}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    className="p-2 text-gray-600 hover:text-black hover:bg-gray-100 rounded-r-md transition-colors"
                                                                    onClick={() => updateLineItemQuantity(item.id, item.quantity + 1)}
                                                                >
                                                                    <FaPlus size={12} />
                                                                </button>
                                                            </div>

                                                            <div className="flex">
                                                                {/* Remove item functionality can be added here if needed */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="text-center text-gray-500 mt-10">Sepetiniz boş.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {checkout.lineItems && checkout.lineItems.length > 0 && (
                            <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                                <div className="flex justify-between text-base font-medium text-gray-900">
                                    <p>Ara Toplam</p>
                                    <p>{checkout.subtotalPrice.amount} {checkout.subtotalPrice.currencyCode}</p>
                                </div>
                                <p className="mt-0.5 text-sm text-gray-500">Kargo ve vergiler ödeme adımında hesaplanır.</p>
                                <div className="mt-6">
                                    <a
                                        href={checkout.webUrl}
                                        className="flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-black hover:bg-gray-800"
                                    >
                                        Ödeme Yap
                                    </a>
                                </div>
                                <div className="mt-6 flex justify-center text-sm text-center text-gray-500">
                                    <p>
                                        veya{' '}
                                        <button
                                            type="button"
                                            className="text-indigo-600 font-medium hover:text-indigo-500"
                                            onClick={closeCart}
                                        >
                                            Alışverişe Devam Et<span aria-hidden="true"> &rarr;</span>
                                        </button>
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;
